import { TransformWrapper, TransformComponent, useControls } from 'react-zoom-pan-pinch';
import { Team, Venue, KnockoutMatch } from '../types/tournament';
import { KnockoutBracket } from './KnockoutBracket';

interface BracketCanvasProps {
  matches: KnockoutMatch[];
  teams: Team[];
  venues: Venue[];
}

function ZoomControls() {
  const { zoomIn, zoomOut, resetTransform } = useControls();

  return (
    <div className="absolute bottom-4 right-4 flex flex-col gap-2 z-10">
      <button
        onClick={() => zoomIn()}
        className="w-10 h-10 bg-white rounded-lg shadow-md border border-gray-200 flex items-center justify-center text-xl font-bold text-gray-600 hover:bg-gray-50 transition-colors"
        title="Zoom in"
      >
        +
      </button>
      <button
        onClick={() => zoomOut()}
        className="w-10 h-10 bg-white rounded-lg shadow-md border border-gray-200 flex items-center justify-center text-xl font-bold text-gray-600 hover:bg-gray-50 transition-colors"
        title="Zoom out"
      >
        −
      </button>
      <button
        onClick={() => resetTransform()}
        className="w-10 h-10 bg-white rounded-lg shadow-md border border-gray-200 flex items-center justify-center text-sm font-medium text-gray-600 hover:bg-gray-50 transition-colors"
        title="Reset view"
      >
        ⟲
      </button>
    </div>
  );
}

export function BracketCanvas({ matches, teams, venues }: BracketCanvasProps) {
  return (
    <div className="relative w-full h-full bg-slate-100 overflow-hidden">
      <TransformWrapper
        initialScale={0.6}
        minScale={0.2}
        maxScale={2}
        centerOnInit
        wheel={{ step: 0.1 }}
        panning={{ velocityDisabled: true }}
      >
        <ZoomControls />
        <TransformComponent
          wrapperStyle={{
            width: '100%',
            height: '100%',
          }}
        >
          <div className="p-8">
            <KnockoutBracket
              matches={matches}
              teams={teams}
              venues={venues}
            />
          </div>
        </TransformComponent>
      </TransformWrapper>

      {/* Instructions */}
      <div className="absolute top-4 left-4 bg-white/90 backdrop-blur-sm rounded-lg shadow-sm px-3 py-2 text-sm text-gray-600">
        <p>🖱️ Drag to pan • Scroll to zoom • Click teams to predict</p>
      </div>
    </div>
  );
}
